import { render, staticRenderFns } from "./newsTags.vue?vue&type=template&id=0a4e6fe6&scoped=true"
import script from "./newsTags.vue?vue&type=script&lang=js"
export * from "./newsTags.vue?vue&type=script&lang=js"
import style0 from "./newsTags.vue?vue&type=style&index=0&id=0a4e6fe6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4e6fe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a4e6fe6')) {
      api.createRecord('0a4e6fe6', component.options)
    } else {
      api.reload('0a4e6fe6', component.options)
    }
    module.hot.accept("./newsTags.vue?vue&type=template&id=0a4e6fe6&scoped=true", function () {
      api.rerender('0a4e6fe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/industryChainNew/components/newsTags.vue"
export default component.exports